export const runWhenIdle = (callback, { timeout = 3000 } = {}) => {
  if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
    const idleCallbackId = window.requestIdleCallback(callback, { timeout });

    return () => {
      if (typeof window.cancelIdleCallback === 'function') {
        window.cancelIdleCallback(idleCallbackId);
      }
    };
  }

  const timeoutId = setTimeout(callback, timeout);
  return () => clearTimeout(timeoutId);
};
